/**
 * @todo поправить нейминг
 */
export const FILTERS_TOPIC = 'commercial_filters';
export const TOPIC_USER = 'user';
